import api from "./api";

const labService = {};
const endpoint = "/labs";

labService.getLabs = function (search = "", isActive = true) {
  const params = new URLSearchParams();
  if (search) params.append("search", search);
  if (isActive !== undefined) params.append("isActive", isActive);

  return api.get(`${endpoint}?${params.toString()}`).then((res) => res.data);
};

labService.getLabByCode = function (code) {
  return api.get(`${endpoint}/code/${code}`).then((res) => res.data);
};

labService.getLab = function (id) {
  return api.get(`${endpoint}/${id}`).then((res) => res.data);
};

labService.createLab = function (labData) {
  return api.post(endpoint, labData).then(({ data }) => data);
};

labService.updateLab = function (id, labData) {
  return api.put(`${endpoint}/${id}`, labData).then(({ data }) => data);
};

labService.deleteLab = function (id) {
  return api.delete(`${endpoint}/${id}`).then(({ data }) => data);
};

export default labService;
